import { render, staticRenderFns } from "./UsersSearch.vue?vue&type=template&id=965475de"
import script from "./UsersSearch.vue?vue&type=script&lang=js"
export * from "./UsersSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports